<template>
    <v-flex d-inline-block>
        <bc-tooltip v-if="button && hasCam">
            <template slot="activator">
                <v-btn
                    class="d-inline-block"
                    :class="{ 'my-auto': align == 'center', 'mb-auto': align == 'top' }"
                    :dark="dark"
                    icon
                    @mouseup.left="scanQRDialog = true"
                >
                    <v-icon class="material-icons-outlined">qr_code</v-icon>
                </v-btn>
            </template>
            {{ $t("lang.scan_code") }}
        </bc-tooltip>
        <bc-dialog :value="scanQRDialog && hasCam" max-width="600">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.scan_code") }}</span>
                    <v-spacer></v-spacer>
                    <bc-tooltip :disabled="loading">
                        <template slot="activator">
                            <v-btn v-if="!missingCam" :disabled="loading" icon dark @click="switchCamera()">
                                <v-icon dark>cameraswitch</v-icon>
                            </v-btn>
                        </template>
                        {{ $t("lang.switch_camera") }}
                    </bc-tooltip>
                    <bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closeDialog" :dialog-status="scanQRDialog"></bc-btn-dialog-close>
                </v-card-title>
                <!-- qr code scanner goes here -->
                <v-card-text class="pa-0" :style="{ height: setHeight }">
                    <v-container pa-0 h-100>
                        <v-layout h-100>
                            <v-flex h-100 w-100>
                                <bc-camera
                                    ref="camera"
                                    v-if="scanQRDialog"
                                    :start="start"
                                    @timeout="pauseCam()"
                                    @scanned="$emit('scanned', $event)"
                                    @close="scanQRDialog = false"
                                    @loader="isLoaded"
                                    @no-cam="updateCam()"
                                ></bc-camera>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="current" color="error" @mouseup.left="openDelete()">{{ $t("lang.delete") }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeDialog()">{{ $t("lang.cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_qr_code"
            :heading="$t('lang.delete_qr_code')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="$emit('scanned', 'DELETE')"
            @close="closeDelete()"
        ></delete-confirmation-dialog>
    </v-flex>
</template>

<script>
//camera for qr codes
import BcCamera from "Components/Camera/BcCamera";

export default {
    props: {
        dark: {
            default: true,
        },
        align: {
            default: "middle",
        },
        button: {
            default: true,
        },
        start: {
            default: undefined,
        },
        current: {
            default: null,
        },
    },
    data() {
        return {
            scanQRDialog: false,
            loading: false,
        };
    },
    methods: {
        isLoaded(status) {
            this.loading = status;
        },
        openDelete() {
            this.$refs.delete_qr_code.openDialog();
            this.pauseCam();
        },
        pauseCam() {
            if (this.$refs.camera) this.$refs.camera.pause();
        },
        closeDelete() {
            this.$refs.camera.unpause();
        },
        switchCamera() {
            this.$refs.camera.switchCamera();
        },
        toggleLoader() {
            this.$refs.camera.toggleLoader();
        },
        openDialog() {
            this.scanQRDialog = true;
        },
        closeDialog() {
            this.scanQRDialog = false;
            if (this.$refs.delete_qr_code) this.$refs.delete_qr_code.close(false);
            this.pauseCam();
        },
        updateCam() {
            this.scanQRDialog = false;
            this.$emit("error");
        },
    },
    computed: {
        setHeight() {
            if (this.$bp.smallScreen) {
                if (this.$bp.xs) {
                    return "calc(100vh - 120px)";
                } else {
                    return "calc(100vh - 124px)";
                }
            } else {
                return "500px";
            }
        },
        hasCam() {
            let front_cam = $cookies.get("bc-front-cam");
            let rear_cam = $cookies.get("bc-rear-cam");
            return !(front_cam == "0" && rear_cam == "0");
        },
        missingCam() {
            let front_cam = $cookies.get("bc-front-cam");
            let rear_cam = $cookies.get("bc-rear-cam");
            return front_cam == "0" || rear_cam == "0";
        },
    },
    components: {
        BcCamera,
    },
};
</script>
